export default function SvgVideo6() {
    return (
      <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#000"
		width="20px"
        cursor="pointer"
        version="1.1"
        viewBox="0 0 32 32"
        xmlSpace="preserve"
      >
        <path d="M31 31.36H1v-.72h30v.72zm0-7H1A.36.36 0 01.64 24V2A.36.36 0 011 1.64h30a.36.36 0 01.36.36v22a.36.36 0 01-.36.36zm-29.64-.72h29.28V2.36H1.36v21.28zm10.645-5.088a.36.36 0 01-.36-.361V7.799a.36.36 0 01.54-.312l9 5.197a.36.36 0 010 .624l-9 5.196a.373.373 0 01-.18.048zm.36-10.13v9.145l7.92-4.572-7.92-4.573z"></path>
        <path fill="none" d="M0 0H32V32H0z"></path>
      </svg>
  </>
  );
}
